/**
 * Generate a unique device ID based on browser fingerprint
 * This creates a consistent identifier for the device/browser combination
 */
export const generateDeviceId = (): string => {
  try {
    // Create canvas fingerprint
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    if (ctx) {
      ctx.textBaseline = 'top';
      ctx.font = '14px "Arial"';
      ctx.textBaseline = 'alphabetic';
      ctx.fillStyle = '#f60';
      ctx.fillRect(125, 1, 62, 20);
      ctx.fillStyle = '#069';
      ctx.fillText('Device fingerprint', 2, 15);
      ctx.fillStyle = 'rgba(102, 204, 0, 0.7)';
      ctx.fillText('Device fingerprint', 4, 17);
    }
    const canvasFingerprint = canvas.toDataURL();
    
    // Collect device characteristics
    const fingerprint = [
      navigator.userAgent,
      navigator.language,
      window.screen.width + 'x' + window.screen.height,
      window.screen.colorDepth,
      new Date().getTimezoneOffset(),
      navigator.platform,
      navigator.hardwareConcurrency || 0,
      navigator.maxTouchPoints || 0,
      canvasFingerprint.substring(0, 100),
    ].join('|');
    
    // Create a hash from the fingerprint
    let hash = 0;
    for (let i = 0; i < fingerprint.length; i++) {
      const char = fingerprint.charCodeAt(i);
      hash = ((hash << 5) - hash) + char;
      hash = hash & hash; // Convert to 32-bit integer
    }
    
    // Generate a readable device ID
    const deviceId = `DEVICE-${Math.abs(hash).toString(36).toUpperCase().padStart(8, '0')}`;
    
    // Store in localStorage for consistency
    const storedDeviceId = localStorage.getItem('deviceId');
    if (storedDeviceId) {
      return storedDeviceId;
    }
    
    localStorage.setItem('deviceId', deviceId);
    return deviceId;
  } catch (error) {
    // Fallback to a simple ID if fingerprinting fails
    let fallbackId = localStorage.getItem('deviceId');
    if (!fallbackId) {
      fallbackId = `DEVICE-${Date.now().toString(36).toUpperCase()}`;
      localStorage.setItem('deviceId', fallbackId);
    }
    return fallbackId;
  }
};

